import * as React from 'react';
import { LucideIcon } from 'lucide-react';
import { DMDiv, DMText } from '../Primitives';

interface SectionHeaderProps {
  title: string;
  icon?: LucideIcon;
}

export const SectionHeader = ({ title, icon: Icon }: SectionHeaderProps) => (
  <DMDiv className="pb-[0.1vh]">
    <DMText className="text-[1.6vh] font-bold text-gray-800 uppercase flex items-center gap-[1vh]">
      {Icon && <Icon className="w-[2vh] h-[2vh]" />}
      {title}
    </DMText>
  </DMDiv>
);
